









import { defineComponent, toRefs } from '@vue/composition-api';
export default defineComponent({
  name: 'drawer',
  props: {
    titleV: String,
    detail: String,
    icon: String,
  },
});
